export enum BidcompApiConfig {
  dev = 'https://dev.bidcomp.globalmarkets.ihsmarkit.com',
  qx = 'https://qa.bidcomp.globalmarkets.ihsmarkit.com',
  demo = 'https://uat.bidcomp.globalmarkets.ihsmarkit.com',
  perf = 'https://perf.bidcomp.globalmarkets.ihsmarkit.com',
  mo = 'https://demo.bidcomp.globalmarkets.ihsmarkit.com',
  prod = 'https://bidcomp.globalmarkets.ihsmarkit.com'
}
